import { Component, Prop, Vue } from 'vue-property-decorator'
import { CancelToken } from 'axios'

@Component
export default class VtPersonnelProfileImage extends Vue {
    @Prop({ type: Number }) personnelId!: number
    @Prop({ type: Object }) cancelToken!: CancelToken

    @Prop({ type: String }) imgTooltip!: string
    @Prop({ type: String }) imgClass!: string
    @Prop({ type: String }) imgStyle!: string
    @Prop({ type: String, default: 'user-image' }) imgAlt!: string
    @Prop({ type: String }) imgQa!: string

    async getLastPersonnelProfileImage(): Promise<string> {
        if (this.personnelId) {
            const lastProfileImage = await this.$_getProfileImage(this.personnelId, this.cancelToken)
            if (lastProfileImage) {
                return lastProfileImage
            }
        }
        return require('@/img/user-img.png')
    }
}
